module.exports = __webpack_public_path__ + "img/Asset186.678438d4.svg";